export default __webpack_public_path__ + "/dist/images/image00018.791e825d6d6f20997ce820616c3aec4a.jpeg";